module.exports = __webpack_public_path__ + "static/media/noStudents.3db7f749.svg";